<template>
  <b-card class="mb-4" no-header>
    <b-row>
      <b-col cols="12">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <!-- TODO: Ubah judul Laporan sesuai pilihan yang diseleksi -->
          <h5>Laporan</h5>
          <b-button-group class="add-button-group ml-auto">
            <b-btn variant="success" type="button" @click.prevent="doExport"
              ><font-awesome-icon icon="file-excel" /> Ekspor</b-btn
            >
          </b-button-group>
        </div>
      </b-col>
      <b-col cols="12" class="mb-4">
        <b-form @submit.prevent="doFilter">
          <b-row class="filter-row">
            <b-col cols="6" md="3">
              <form-group-input
                ref="filter-name"
                type="enum"
                :options="list.tahun_anggaran"
                v-model="filter.tahun_anggaran"
                placeholder=""
                :need-label="true"
                label="tahun anggaran"
                id="filter-name"
              />
            </b-col>
            <b-col cols="6" md="2">
              <label class="form-label">&nbsp;</label><br />
              <b-btn
                type="submit"
                @click.prevent="doFilter"
                class="btn-in-form"
                variant="primary"
              >
                <font-awesome-icon icon="search" /><span>Cari</span>
              </b-btn>
              <b-btn
                type="button"
                @click.prevent="clearForm"
                variant="secondary"
                class="btn-in-form ml-2"
              >
                <font-awesome-icon icon="broom" /><span>Clear</span>
              </b-btn>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
    <paginated-table
      ref="dataTable"
      :delete-reason="false"
      :can-delete="true"
      :can-edit="false"
      :data-url="apiUrl.planning"
      :data-columns="columns"
      :dataParams="dataParams"
      :defaultDataParams="this.filter"
    >
    </paginated-table>
  </b-card>
</template>

<script>
import { objectToOptions, classicObjectToOptions } from "@/_helpers";
import paginatedTable from "@/components/PaginatedTable.vue";
import formGroupInput from "@/components/FormGroupInput.vue";

export default {
  components: {
    formGroupInput,
    paginatedTable,
  },
  data() {
    return {
      isLoading: false,
      totalPromiseAreaCount: 0,
      apiUrl: {
        planning: "http://localhost:8080/planning",
      },
      columns: [
        {
          prop: "kode_rek",
          label: "Kode Rek",
          sortable: true,
          resizable: true,
          minWidth: 200,
          wrapInLink: true,
        },
        {
          prop: "uraian_kegiatan",
          label: "Uraian Kegiatan",
          sortable: true,
          resizable: true,
          minWidth: 200,
          wrapInLink: true,
        },
        {
          prop: "volume",
          label: "Vol",
          sortable: true,
          resizable: true,
          minWidth: 200,
          wrapInLink: true,
        },
        {
          prop: "frekuensi",
          label: "Frek",
          sortable: true,
          resizable: true,
          minWidth: 200,
          wrapInLink: true,
        },
        {
          prop: "satuan",
          label: "Satuan",
          sortable: true,
          resizable: true,
          minWidth: 200,
          wrapInLink: true,
        },
        {
          prop: "harga",
          label: "Harga",
          sortable: true,
          resizable: true,
          minWidth: 200,
          wrapInLink: true,
        },
        {
          prop: "jumlah",
          label: "Jumlah",
          sortable: true,
          resizable: true,
          minWidth: 200,
          wrapInLink: true,
        },
        {
          prop: "bulan",
          label: "Bulan",
          sortable: true,
          resizable: true,
          minWidth: 200,
          wrapInLink: true,
        },
      ],
      list: {
        tahun_anggaran: ["2023", "2022"],
      },
      filter: {
        tahun_anggaran: null,
      },
      dataParams: [],
    };
  },
  beforeMount() {
    this.$router.push({ query: { ...this.$route.query } }).catch((err) => {});
  },
  async mounted() {},
  watch: {},
  methods: {
    clearForm() {
      this.$nextTick(() => {
        this.filter = {
          tahun_anggaran: null,
        };
        setTimeout(() => {
          this.doFilter();
        }, 100);
      });
    },
    doFilter() {
      this.$refs.dataTable.doFilter(this.filter);
    },
    doExport() {
      if (this.isLoading) {
        return false;
      }
      this.isLoading = true;
      const filterArray = [];
      Object.keys(this.filter).forEach((key) => {
        if (this.filter[key]) {
          filterArray.push(key + "=" + this.filter[key]);
        }
      });
      filterArray.push("csv=1");

      this.$http
        .get(userModel.getEndpoint() + "?" + filterArray.join("&"))
        .then((response) => {
          const a = document.createElement("a");

          const blob = new Blob([response.data], { type: "octet/stream" });
          a.href = window.URL.createObjectURL(blob);

          a.download = "data_admin.csv";
          a.click();
          this.isLoading = false;
        })
        .catch((error) => {
          this.$store.dispatch("notification/error", error);
          this.isLoading = false;
        });
    },
  },
};
</script>